export * from './iconFontAwesomeMaritimeFish';
export * from './iconFontAwesomeMaritimeAnchor';
export * from './iconFontAwesomeMaritimeWater';
export * from './iconFontAwesomeMaritimeShip';
export * from './iconFontAwesomeMaritimeOtter';
export * from './iconFontAwesomeMaritimeShrimp';
export * from './iconFontAwesomeMaritimeSailboat';
export * from './iconFontAwesomeMaritimePersonSwimming';
export * from './iconFontAwesomeMaritimeFishFins';
export * from './iconFontAwesomeMaritimeFerry';
export * from './iconFontAwesomeMaritimeAnchorLock';
export * from './iconFontAwesomeMaritimeAnchorCircleXmark';
export * from './iconFontAwesomeMaritimeAnchorCircleExclamation';
export * from './iconFontAwesomeMaritimeAnchorCircleCheck';
